/* eslint-disable */
jQuery(function ($) {
	// Apply additional classes to reply box
	$( '.bbp-reply-form' ).addClass( 'bb-modal bb-modal-box' );

	// Trigger on load functionality
	ama_update_reply_to_links();
	ama_fix_show_reply_links();
	var $ama_spinner = $( '<span><i class="spinner is-active"></i></span>' );

	// See more/less links for forum archive pages
	// the .see-less link gets caught up inside the .content element somehow so there is a fix to insert it where it is required
	$( '.bs-forums-items .item-desc .content' ).each( function( index, element ) {
		$( element ).find( '.show-less' ).insertAfter( $( this ) );
	}); 
	$( '.bs-forums-items .item-desc' ).on( 'click', '.show-more', function( e ) {
		e.preventDefault();
		var parent = $( this ).closest( '.item-desc' );
		parent.find( '.show-more, .excerpt' ).hide();
		parent.find( '.show-less, .content' ).show();
	});
	$( '.bs-forums-items .item-desc' ).on( 'click', '.show-less', function( e ) {
		e.preventDefault();
		var parent = $( this ).closest( '.item-desc' );
		parent.find( '.show-less, .content' ).hide();
		parent.find( '.show-more, .excerpt' ).show();
		$( [document.documentElement, document.body] ).animate({
			scrollTop: parent.find( '.excerpt' ).offset().top - 200
		}, 500);
	});

	/**
	 * Load replies for topic
	 * We check if we are just showing/hiding the element based on whether replies were already pulled in
	 */
	$( '.bs-forums-items li' ).on( 'click', '.bs-replies.not-shown', function() {{
		var $topic_id  = $( this ).closest( '.item' ).data( 'topic-id' );
		if ( $( this ).hasClass( 'loaded' ) ) {
			$( '#topic-'+$topic_id+'-replies' ).show();
		} else {
			ama_get_replies( $topic_id );
		}
		$( this ).addClass( 'shown' ).removeClass( 'not-shown' );
	}});
	/**
	 * Hide the replies <ul> and update classes accordingly
	 */
	$( '.bs-forums-items li' ).on( 'click', '.bs-replies.shown', function() {{
		var $topic_id  = $( this ).closest( '.item' ).data( 'topic-id' );
		$( '#topic-'+$topic_id+'-replies' ).hide();
		$( this ).addClass( 'not-shown' ).removeClass( 'shown' );
	}});
	/**
	 * Load more replies
	 */
	$( '.bs-forums-items' ).on( 'click', '.load-more', function( e ) {
		e.preventDefault();
		var $topic_id  = $( this ).closest( '.item' ).data( 'topic-id' );
		ama_show_replies( $topic_id );
	});
	/**
	 * Grab replies by hitting our custom endpoint (see api/buddyboss/forums.php)
	 * 
	 * @param {int} $topic_id parent topic ID for replies
	 * @param {boolean} $scroll_to do we want to scroll to the latest comment (used when a new comment is added before the replies are loaded)
	 * @param {string} $show 'show' = show next 15 replies, 'hide' = show first 15 replies (hide all others), 'all' = show all replies
	 */
	function ama_get_replies( $topic_id = 0, $scroll_to = false, $show = 'hide' ) {
		$ama_spinner.insertAfter( $( '.bs-replies[data-topic-id="'+$topic_id+'"]' ) );
		$.ajax( {
			url: wpApiSettings.root + 'ama/v1/get-topic-replies/',
			method: 'GET',
			beforeSend: function ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
			data:{
				'topic_id': $topic_id
			}
		} ).done( function ( $response ) {
			$ama_spinner.remove();
			$( $response ).appendTo( $( '.bs-item-list .item[data-topic-id="'+$topic_id+'"]' ) );
			ama_show_replies( $topic_id, $show );
			ama_update_reply_to_links( $topic_id );
			if ( $scroll_to ) {
				// Scroll to last reply
				$( 'html,body' ).animate( {
					scrollTop: $( '#topic-'+$topic_id+'-replies > li:last' ).offset().top - 200
				});
			}
			$( '.item[data-topic-id="'+$topic_id+'"] .bb-reply-meta .bs-replies' ).addClass( 'loaded' );
		} );
	}
	/**
	 * Retrieve amount of replies to show (15 root replies per load)
	 * Hide any replies above this
	 * Show the load-more option if we have more replies hidden
	 * Update the data attribute to reflect how many replies are shown
	 * @param {int} $topic_id 
	 * @param {string} $type  'show' = show next 15 replies, 'hide' = show first 15 replies (hide all others), 'all' = show all replies
	 */
	function ama_show_replies( $topic_id = 0, $type = 'show' ) {
		if ( 'all' === $type ) {
			$( '#topic-'+$topic_id+'-replies li.depth-1' ).show();
			$( '#topic-'+$topic_id+'-replies .load-more-wrap' ).hide();
		} else {
			var $root_replies_to_show = $( '#topic-'+$topic_id+'-replies' ).data( 'to-show' );
			if ( 'hide' === $type ) {
				$( '#topic-'+$topic_id+'-replies li.depth-1' ).slice( $root_replies_to_show ).each( function() {
					$( this ).hide();
				});
			} else {
				$root_replies_to_show += 15;
				$( '#topic-'+$topic_id+'-replies li.depth-1' ).slice( 0, $root_replies_to_show  ).each( function() {
					$( this ).show();
				});
				$( '#topic-'+$topic_id+'-replies' ).data( 'to-show', $root_replies_to_show );
			}
			if ( $( '#topic-'+$topic_id+'-replies li.depth-1' ).length > $root_replies_to_show ) {
				$( '#topic-'+$topic_id+'-replies .load-more-wrap' ).show();
			} else {
				$( '#topic-'+$topic_id+'-replies .load-more-wrap' ).hide();
			}
		}
		$( '.item[data-topic-id="'+$topic_id+'"] .bb-reply-meta .bs-replies' ).addClass( 'shown' ).removeClass( 'not-shown' );
	}

	/**
	 * Add wrapper to move form function so the appropriate ID is set ahead of the function running
	 * ID is set on page load typically but it is not loaded in due to this being an archive page
	 */
	window.AMAaddReply = {
		moveForm: function ( replyId, parentId, respondId, postId ) {
			var id = $( '#'+replyId ).find( '.bbp-reply-to-link' ).data( 'modal-id-inline' );
			if ( ! $( '#'+id ).length ) {
				$( "[id^=new-reply-]" ).attr( 'id', id );
			}
			window.addReply.moveForm( replyId, parentId, respondId, postId );
		}
	};

	/**
	 * Update the onclick event on reply_to links to force load our custom function
	 * This needs to happen on page load to adjust the reply links for topics and when we load in replies to adjust the reply links for those replies
	 * @param {int} $topic_id 
	 */
	function ama_update_reply_to_links( $topic_id = 0 ) {
		if ( 0 === $topic_id ) {
			var $elements = $( '.item-title .bbp-reply-to-link' );
		} else {
			var $elements = $( '#topic-'+$topic_id+'-replies .bbp-reply-to-link' );
		}
		$elements.each( function( $index, $element ) {
			var $attribute = $( $element ).attr( 'onClick' );
			if ( $attribute ) {
				var $new_attr  = $attribute.replace( 'addReply', 'AMAaddReply' );
				$( $element ).attr( 'onClick', $new_attr );
			}
		});
	}

	/**
	 * For some reason the reply links & actions are being moved to inside the ".content" section.  This moves them back to where they should be
	 */
	function ama_fix_show_reply_links() {
		$( '.item-meta.bb-reply-meta' ).each( function( $index, $element ) {
			if ( $( $element ).closest( 'span.content' ).length ) {
				$( $element ).insertAfter( $( $element ).closest( '.item-desc' ) );
			}
		});
		$( 'div.bbp-meta' ).each( function( $index, $element ) {
			if ( $( $element ).closest( 'span.content' ).length ) {
				$( $element ).insertAfter( $( $element ).closest( '.item-desc' ) );
			}
		});
	}

	if ( $( 'body.forum-archive' ).length || $( 'body.forum' ).length ) {
		/**
		 * On load reply modal
		 * - update the topic ID of the hidden input on the reply modal so that it can be pulled in when needed
		 * - update excerpt and author name in modal
		 */
		$( 'body' ).on( 'bbp_after_load_reply_form', function( event, button ) {
			var $topic    = $( button.click_event ).closest( '.bs-item-wrap' );
			var $topic_id = $topic.find( '.item' ).data( 'topic-id' );
			var $name     = $topic.find( '.bb-item-avatar-wrap .bbp-author-name' ).text();
			var $excerpt  = $topic.find( '.bbp_topic_excerpt' ).val();
			$( '#bbp_topic_id' ).val( $topic_id );
			if ( ! $( '#new-reply-'+$topic_id ).length ) {
				$( "[id^=new-reply-]" ).attr( 'id', 'new-reply-'+$topic_id );
			}
			$( '#new-reply-'+$topic_id+' #bbp-reply-to-user' ).html( $name );
			$( '#new-reply-'+$topic_id+' #bbp-reply-exerpt' ).text( $excerpt );
		});

		/**
		 * When a new reply is added scroll to it (possibly load in the comments if reply is added to a topic)
		 */
		$( document ).on( 'bbp_after_submit_reply_form', '.bbp-reply-form', function( event, data ) {
			if ( data.response.success ) {
				// Update reply count
				$( '.bs-replies[data-topic-id="'+data.topic_id+'"]' ).text( data.response.total_reply_count );
				if ( ! $( 'ul#topic-'+data.topic_id+'-replies' ).length ) {
					// No replies have been loaded, load them in
					ama_get_replies( data.topic_id, true, 'all' );
				} else {
					// Topic relies are automatically added to the end of ALL open reply threads
					// Remove any of these replies without the correct parent <ul> element (topic ID)
					if ( $( '#post-'+data.response.reply_id ).length ) {
						console.log( 'element found' );
						$( '#post-'+data.response.reply_id ).each( function( $index, $element ) {
							if ( 'topic-'+data.topic_id+'-replies' !== $( $element.closest( 'ul' ) ).attr( 'id' ) ) {
								$element.closest( 'li.depth-1' ).remove();
							}
						});
					}
					if ( ! $( '#post-'+data.response.reply_id ).length ) {
						// Topic replies are not added automatically on all occassions, add them in if needed
						$( '<li class="depth-1" data-depth="1" style="">'+data.response.content+'</li>' ).appendTo( 'ul#topic-'+data.topic_id+'-replies' );
						ama_show_replies( data.topic_id, 'all' );
					} else {
						if ( ! $( '#post-'+data.response.reply_id ).is( ':visible' ) ) {
							// Replies are loaded but the newly added one is not visible, show them all
							ama_show_replies( data.topic_id, 'all' );
						}
					}
					// Scroll to current reply
					$( 'html,body' ).animate( {
						scrollTop: $( '#post-'+data.response.reply_id ).offset().top - 200
					});
				}
			}
		});

		/**
		 * Apply logic for subscribe & favourite
		 */
		$( '.bbp-meta' ).on( 'click', '.bbp-subscribe-link', function( e ) {
			e.preventDefault();
			var link      = $( this );
			var $text     = $( this ).find( '.bb-forum-subscribe-text' ).text().trim();
			var $topic_id = $( this ).data( 'topic-id' );
			var $user_id  = $( this ).data( 'user-id' );
			link.hide();
			$ama_spinner.insertAfter( link );
			$.ajax( {
				url: wpApiSettings.root + 'ama/v1/update-topic-subscription/?topic_id='+$topic_id+'&user_id='+$user_id,
				method: 'POST',
				beforeSend: function ( xhr ) {
					xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				},
				data:{
					'topic_id': $topic_id,
					'user_id': $user_id
				}
			} ).done( function ( $response ) {
				if ( $response ) {
					if ( 'Subscribe' === $text ) {
						$( 'a#subscribe-'+$topic_id+' .bb-forum-subscribe-text' ).text( 'Unsubscribe' );
					} else {
						$( 'a#subscribe-'+$topic_id+' .bb-forum-subscribe-text' ).text( 'Subscribe' );
					}
				} else {
					console.log( 'failed to subscribe' );
				}
				$ama_spinner.remove();
				link.show();
			});
		});
		$( '.bbp-meta' ).on( 'click', '.bbp-favorite-link', function( e ) {
			e.preventDefault();
			var link      = $( this );
			var $text     = $( this ).find( '.bb-forum-favorite-text' ).text().trim();
			var $topic_id = $( this ).data( 'topic-id' );
			var $user_id  = $( this ).data( 'user-id' );
			link.hide();
			$ama_spinner.insertAfter( link );
			$.ajax( {
				url: wpApiSettings.root + 'ama/v1/update-topic-favorite/?topic_id='+$topic_id+'&user_id='+$user_id,
				method: 'POST',
				beforeSend: function ( xhr ) {
					xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				},
				data:{
					'topic_id': $topic_id,
					'user_id': $user_id
				}
			} ).done( function ( $response ) {
				if ( $response ) {
					if ( 'Favorite' === $text ) {
						$( 'a#favorite-'+$topic_id+' .bb-forum-favorite-text' ).text( 'Unfavorite' );
					} else {
						$( 'a#favorite-'+$topic_id+' .bb-forum-favorite-text' ).text( 'Favorite' );
					}
				} else {
					console.log( 'failed to favorite' );
				}
				$ama_spinner.remove();
				link.show();
			} );
		});
	}
	/**
	 * Handle sidebar menu for forums (smaller screens)
	 */
	function AMAForumCloseMenu() {
		$( '.ama-forum-menu' ).css( 'left', '-260px' );
		$( '.ama-forum-menu' ).removeClass( 'open' ).addClass( 'closed' );
		$( '.ama-forum-menu-mobile' ).css( 'left', '0' );
		$( '#content > .container' ).css( 'left', '0' );
		$( '.ama-forum-menu-mobile i' ).removeClass( 'bb-icon-angle-left' ).addClass( 'bb-icon-angle-right' );
	}
	function AMAForumOpenMenu() {
		$( '.ama-forum-menu' ).css( 'left', '0' );
		$( '.ama-forum-menu' ).removeClass( 'closed' ).addClass( 'open' );
		$( '.ama-forum-menu-mobile' ).css( 'left', '260px' );
		$( '#content > .container' ).css( 'left', '260px' );
		$( '.ama-forum-menu-mobile i' ).removeClass( 'bb-icon-angle-right' ).addClass( 'bb-icon-angle-left' );
	}
	// Handle open and closing when clicking menu icons
	$( '.ama-forum-menu' ).on( 'click', '.ama-forum-menu-mobile i', function() {
		if ( $( '.ama-forum-menu' ).hasClass( 'closed' ) ) {
			AMAForumOpenMenu();
		} else {
			AMAForumCloseMenu();
		}
	});

	// Reset sidebar menu on screen resize
	$( window ).on( 'resize', function() {
		$( '#content > .container' ).css( 'left', '0' );
		$( '.ama-forum-menu-mobile' ).css( 'left', '0' );
		$( '.ama-forum-menu' ).removeClass( 'open' ).addClass( 'closed' );
		if ( $( window ).width() >= 1025 ) {
			$( '.ama-forum-menu' ).css( 'left', '0' );
		} else {
			$( '.ama-forum-menu' ).css( 'left', '-260px' );
		}
	} );

	// Handle loading of iframe popup
	$( '#bbpress-forums .item' ).on( 'click', '.ama-open-email-iframe', function( e ) {
		e.preventDefault();
		if ( $( this ).hasClass( 'bbp-topic-permalink' ) ) {
			var iframe_link = $( this ).closest( '.item' ).find( '.excerpt a.ama-open-email-iframe' ).data( 'iframe' );
		} else {
			var iframe_link = $( this ).data( 'iframe' );
		}
		$( '.iframe-overlay' ).append( '<iframe src="'+iframe_link+'"></iframe>' );
		$( '.iframe-overlay' ).show();
	});
	$( '#page' ).on( 'click', '.iframe-overlay, .iframe-close', function( e ) {
		e.preventDefault();
		e.stopPropagation();
		$( '.iframe-overlay' ).hide();
		$( '.iframe-overlay iframe' ).remove();
	});
});